export const PaymentAdministration = () => {
    return (
        <>Payment</>
    )
}